import { mapActions, mapState } from 'vuex'
import validationMixin from '@components/mixins/validation'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'CreateCampaignModal',
  mixins: [validationMixin],
  props: {
    modalVisible: {
      required: true,
      type: Boolean,
    },
    chosenWidget: {
      required: true,
      type: String,
    },
  },
  data() {
    const checkValidName = (rule, value, callback) => {
      callback(this.validateUniqueName(rule, value, callback))
    }

    const checkValidURL = (rule, value, callback) => {
      callback(this.validateURL(rule, value, callback))
    }

    return {
      showCreateCampaignDialog: false,
      campaignNameError: false,
      selectPlaceholder: 'Select or start typing',
      campaignDetailsForm: {
        name: '',
        domain: { url: '' },
      },
      formRules: {
        name: [{ validator: checkValidName, trigger: 'blur' }],
        domain: [{ validator: checkValidURL, trigger: 'blur' }],
      },
    }
  },
  watch: {
    'campaignDetailsForm.name'() {
      this.campaignNameError = false
    },
    allDomains(val) {
      if (this.campaignDetailsForm.domain.length === 0) {
        this.setCampaignWebsite(val[0], true)
      }
    },
  },
  computed: {
    ...mapState({
      campaignCreationCompleted: (state) =>
        state.campaign.campaignCreationCompleted,
      campaignCreationError: (state) => state.campaign.campaignCreationError,
      campaignCreationLoading: (state) =>
        state.campaign.campaignCreationLoading,
      campaignActionErrorMessage: (state) =>
        state.campaign.campaignActionErrorMessage,
      allDomains: (state) => state.domain.domains,
    }),
    getWidgetTemplateByID() {
      return this.$store.getters['campaign/widget/getWidgetTemplateByID']
    },
    isFeatureLimitedDomains() {
      return this.$store.getters['plans/featureLimits/isFeatureLimited.domains']
    },
    // noMatchText() {
    //   return this.isFeatureLimitedDomains
    //     ? 'You\'ve reached the limit of websites for your plan'
    //     : 'Press Enter to add domain'
    // },
  },
  created() {
    if (this.allDomains.length > 0) {
      this.setCampaignWebsite(this.allDomains[0], true)
    }
  },
  methods: {
    ...mapActions('campaign', ['createCampaign']),
    ...mapActions('domain', [
      'createDomain',
    ]),
    submitForm() {
      this.$refs.campaignDetailsForm.validate((valid) => {
        if (valid) {
          // Check if the domain exists in this.allDomains
          const domain = this.allDomains.find(
            domain => domain.url === this.campaignDetailsForm.domain.url)

          if (domain) {
            // Domain exists, so get the domain's ID and proceed to create the campaign
            this.triggerCreateCampaign(domain.id)
          } else {
            // Domain does not exist, so create the domain first
            this.createDomain({ url: this.campaignDetailsForm.domain.url })
              .then((domainID) => {
                // pass the new domain's ID to triggerCreateCampaign.
                this.triggerCreateCampaign(domainID)
              })
              .catch(error => {
                console.error('Error creating domain:', error)
              })
          }
        } else {
          return false // Form validation failed.
        }
      })
    },
    triggerCreateCampaign(domainID) {
      const widgetItems = []
      const widget = _cloneDeep(this.getWidgetTemplateByID(this.chosenWidget))

      delete widget.id
      widgetItems.push(widget)

      this.createCampaign({
        name: this.campaignDetailsForm.name,
        domainID: domainID,
        widgetItems,
      }).then((response) => {
        if (this.campaignCreationCompleted && !this.campaignCreationError) {
          this.$router.push({ path: `/editor/${response.data.uuid}` })
        } else {
          this.campaignNameError = true
          this.$refs.campaignDetailsForm.validate()
        }
      })
    },
    domainSelectVisibilityChange(value) {
      // hacky way to set the placeholder on every dropdown open
      if (value) {
        this.selectPlaceholder = 'Select or start typing'
        // this.selectPlaceholder = this.isFeatureLimitedDomains
        //   ? 'Select existing website'
        //   : 'Select or start typing'
      } else {
        this.selectPlaceholder = ''
      }
    },
    setCampaignWebsite(value, overrideLimit = false) {
      // hacky way to add domain when limit is not passed
      if (!this.isFeatureLimitedDomains || overrideLimit) {
        this.campaignDetailsForm.domain.url = JSON.parse(JSON.stringify(value.url))
      }
    },
    validateUniqueName(rule, value, callback) {
      if (value === '') {
        return callback(new Error('Please input a name'))
      } else if (this.campaignNameError) {
        return callback(new Error(this.campaignActionErrorMessage))
      }
    },
    validateURL(rule, domain, callback) {
      if (domain.url === '') {
        return callback(new Error('Please input a website'))
      }

      this.campaignDetailsForm.domain.url = domain.url = this.setHttp(
        domain.url)
      // Disable domain check for development, so we can test on 'localhost'
      if (!this.validURL(domain.url) && process.env.NODE_ENV !==
        'development') {
        return callback(new Error('Please input valid website URL'))
      }
    },
    setHttp(url) {
      // eslint-disable-next-line
      if (url.search(/^http[s]?\:\/\//) == -1) {
        url = 'http://' + url
      }
      return url
    },
    closeModal() {
      this.$emit('close-modal')
    },
  },
}
